import React, { useState, useEffect } from 'react';
import api from '../services/api';

const GoIReportPage = () => {
  const [loading, setLoading] = useState(false);
  const [goiData, setGoiData] = useState([]);
  const [error, setError] = useState(null);
const [selectedQuarter, setSelectedQuarter] = useState('all');
  const handleBackClick = () => {
    console.log('Navigate back to reports');
  };

  // Fetch GoI data
  const fetchGoIData = async () => {
    setLoading(true);
    setError(null);
    
    try {
      const authToken = localStorage.getItem('authToken');
      
      const response = await fetch(`${api.BASE_URL}/project/report/infra/goi`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': authToken
        }
      });
      
      if (response.ok) {
        const result = await response.json();
        setGoiData(result.data || []);
      } else {
        throw new Error('Failed to fetch GoI data');
      }
    } catch (error) {
      console.error('Error fetching GoI data:', error);
      setError('Failed to load GoI report data. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  // Fetch data on component mount
  useEffect(() => {
    fetchGoIData();
  }, []);

  // Format date helper
  const formatDate = (dateString) => {
    if (!dateString) return '-';
    try {
      return new Date(dateString).toLocaleDateString('en-IN');
    } catch {
      return dateString;
    }
  };
// Filter data based on selected quarter
const getFilteredData = () => {
  if (selectedQuarter === 'q1') {
    return goiData.filter(row => row.scheme_year && row.scheme_year.includes('25-26'));
  } else if (selectedQuarter === 'q2') {
    return goiData.filter(row => row.scheme_year && row.scheme_year.includes('25s26'));
  }
  return goiData;
};
  // Format currency helper
  const formatCurrency = (amount) => {
    if (!amount && amount !== 0) return '-';
    return parseFloat(amount).toFixed(2);
  };

const downloadExcel = () => {
  const filteredData = getFilteredData();
  
  if (filteredData.length === 0) {
    alert('No data available to download');
    return;
  }

  const headers = [
    'Sl.No',
    'Name of Institution',
    'Scheme & Year',
    'GoI Sanctioned Date',
    'Name of Work',
    'AS Amount (Lakhs)',
    'Fund Released (Lakhs)',
    'Stage (Last Review)',
    'Stage (Current)',
    'Expenditure (Lakhs)',
    'Expenditure %',
    'Completion Date',
    'Remarks'
  ];

  const csvRows = [headers.join(',')];

  filteredData.forEach((row, index) => {
    const values = [
      index + 1,
      `"${(row.institution_name || '-').replace(/"/g, '""')}"`,
      `"${(row.scheme_year || '-').replace(/"/g, '""')}"`,
      formatDate(row.sanctioned_date),
      `"${(row.work_name || '-').replace(/"/g, '""')}"`,
      row.as_amount || 0,
      row.fund_released || 0,
      `"${(row.stage_last_review || '-').replace(/"/g, '""')}"`,
      `"${(row.stage_current || '-').replace(/"/g, '""')}"`,
      row.expenditure || 0,
      row.expenditure_percentage || '-',
      formatDate(row.completion_date),
      `"${(row.remarks || '-').replace(/"/g, '""')}"`
    ];
    csvRows.push(values.join(','));
  });

  const csvContent = '\uFEFF' + csvRows.join('\n');
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  
  const quarterSuffix = selectedQuarter === 'q1' ? '_Q1_25-26' : selectedQuarter === 'q2' ? '_Q2_25s26' : '';
  
  link.setAttribute('href', url);
  link.setAttribute('download', `GoI_Works_Report${quarterSuffix}_${new Date().toISOString().split('T')[0]}.csv`);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      {/* Header */}
      <div className="flex justify-between items-center mb-6">

        <div className="flex gap-3">
          <button
            onClick={fetchGoIData}
            disabled={loading}
            className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors duration-200 disabled:bg-blue-300 disabled:cursor-not-allowed"
          >
            {loading ? 'Refreshing...' : 'Refresh'}
          </button>
     <div className="flex gap-2">
  <select
    value={selectedQuarter}
    onChange={(e) => setSelectedQuarter(e.target.value)}
    className="px-3 py-2 bg-white border border-gray-300 rounded-md text-gray-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500"
    disabled={loading || goiData.length === 0}
  >
    <option value="all">All Data</option>
    <option value="q1">1st Quarter (25-26)</option>
    <option value="q2">2nd Quarter (25s26)</option>
  </select>
  <button
    onClick={downloadExcel}
    disabled={loading || goiData.length === 0}
    className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors duration-200 disabled:bg-green-300 disabled:cursor-not-allowed flex items-center gap-2"
  >
    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
    </svg>
    Download Excel
  </button>
</div>
        </div>
      </div>

      {/* Loading indicator */}
      {loading && (
        <div className="text-center mb-6 p-4 bg-blue-50 rounded-lg">
          <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-3 text-blue-700 font-medium">Loading GoI report data...</p>
        </div>
      )}

      {/* Error message */}
      {error && (
        <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-lg">
          <p className="text-red-700">{error}</p>
        </div>
      )}

      {/* Review of GoI Works */}
      <div className="mb-8 bg-white rounded-lg shadow-sm overflow-hidden">
        <div className="bg-green-200 px-4 py-3">
          <h2 className="text-lg font-semibold text-center text-gray-800">Review of GoI Works</h2>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead className="bg-gray-100">
              <tr>
                <th className="border border-gray-300 px-3 py-2 text-sm font-medium text-gray-700">Sl.No</th>
                <th className="border border-gray-300 px-3 py-2 text-sm font-medium text-gray-700">Name of the Institution</th>
                <th className="border border-gray-300 px-3 py-2 text-sm font-medium text-gray-700">Scheme & Year</th>
                <th className="border border-gray-300 px-3 py-2 text-sm font-medium text-gray-700">GoI Sanctioned Proceedings Date</th>
                <th className="border border-gray-300 px-3 py-2 text-sm font-medium text-gray-700">Name of the Work</th>
                <th className="border border-gray-300 px-3 py-2 text-sm font-medium text-gray-700">AS Amount (Rs. in Lakhs)</th>
                <th className="border border-gray-300 px-3 py-2 text-sm font-medium text-gray-700">Fund Released (Rs. in Lakhs)</th>
                <th className="border border-gray-300 px-3 py-2 text-sm font-medium text-gray-700 bg-orange-100">Stage of the Work<br/>
                  <div className="flex mt-1">
                    <span className="flex-1 text-xs border-r border-gray-300 pr-1">During Last Review</span>
                    <span className="flex-1 text-xs pl-1">As on Date</span>
                  </div>
                </th>
                <th className="border border-gray-300 px-3 py-2 text-sm font-medium text-gray-700">Expenditure incurred so far (Rs. in Lakhs)</th>
                <th className="border border-gray-300 px-3 py-2 text-sm font-medium text-gray-700">% of Expenditure</th>
                <th className="border border-gray-300 px-3 py-2 text-sm font-medium text-gray-700 bg-orange-100">Probable Date of Completion</th>
                <th className="border border-gray-300 px-3 py-2 text-sm font-medium text-gray-700 bg-orange-100">Remarks (Reason for Pendency)</th>
              </tr>
              <tr className="bg-gray-50">
                <th className="border border-gray-300 px-3 py-1 text-xs">1</th>
                <th className="border border-gray-300 px-3 py-1 text-xs">2</th>
                <th className="border border-gray-300 px-3 py-1 text-xs">3</th>
                <th className="border border-gray-300 px-3 py-1 text-xs">4</th>
                <th className="border border-gray-300 px-3 py-1 text-xs">5</th>
                <th className="border border-gray-300 px-3 py-1 text-xs">6</th>
                <th className="border border-gray-300 px-3 py-1 text-xs">7</th>
                <th className="border border-gray-300 px-3 py-1 text-xs bg-orange-100">
                  <div className="flex">
                    <span className="flex-1 border-r border-gray-300 pr-1">8</span>
                    <span className="flex-1 pl-1">9</span>
                  </div>
                </th>
                <th className="border border-gray-300 px-3 py-1 text-xs">10</th>
                <th className="border border-gray-300 px-3 py-1 text-xs">11</th>
                <th className="border border-gray-300 px-3 py-1 text-xs">12</th>
                <th className="border border-gray-300 px-3 py-1 text-xs">13</th>
              </tr>
            </thead>
            <tbody>
         {getFilteredData().length > 0 ? getFilteredData().map((row, index) => (
                <tr key={row.id || index} className="hover:bg-gray-50">
                  <td className="border border-gray-300 px-3 py-2 text-sm text-center">{index + 1}</td>
                  <td className="border border-gray-300 px-3 py-2 text-sm">{row.institution_name || '-'}</td>
                  <td className="border border-gray-300 px-3 py-2 text-sm">{row.scheme_year || '-'}</td>
                  <td className="border border-gray-300 px-3 py-2 text-sm">{formatDate(row.sanctioned_date)}</td>
                  <td className="border border-gray-300 px-3 py-2 text-sm">{row.work_name || '-'}</td>
                  <td className="border border-gray-300 px-3 py-2 text-sm">{formatCurrency(row.as_amount)}</td>
                  <td className="border border-gray-300 px-3 py-2 text-sm">{formatCurrency(row.fund_released)}</td>
                  <td className="border border-gray-300 px-3 py-2 text-sm bg-orange-50">
                    <div className="flex">
                      <span className="flex-1 border-r border-gray-300 pr-2">{row.stage_last_review || '-'}</span>
                      <span className="flex-1 pl-2">{row.stage_current || '-'}</span>
                    </div>
                  </td>
                  <td className="border border-gray-300 px-3 py-2 text-sm">{formatCurrency(row.expenditure)}</td>
                  <td className="border border-gray-300 px-3 py-2 text-sm">{row.expenditure_percentage || '-'}%</td>
                  <td className="border border-gray-300 px-3 py-2 text-sm bg-orange-50">{formatDate(row.completion_date)}</td>
                  <td className="border border-gray-300 px-3 py-2 text-sm bg-orange-50">{row.remarks || '-'}</td>
                </tr>
              )) : (
                <tr>
                  <td colSpan="12" className="border border-gray-300 px-3 py-8 text-sm text-center text-gray-500">
        {loading ? 'Loading...' : selectedQuarter !== 'all' ? 'No data available for selected quarter' : 'No GoI works data available'}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default GoIReportPage;